import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '@/directives/control-value-accessor.directive';
import { Subject } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-make-dropdown-ms',
  templateUrl: './make-dropdown-ms.component.html',
  styleUrls: ['./make-dropdown-ms.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MakeDropdownMsComponent),
      multi: true,
    },
  ],
})
export class MakeDropdownMsComponent<T> extends ControlValueAccessorDirective<T> implements OnInit {
  @Input() multi: boolean = false;
  @Input() meta!: any;
  @Input() triggerSelectionBrand$: Subject<any>;
  @Input() triggerUpdateComponent$ = new Subject<any>();

  ngOnInit() {
    if (this.meta?.default !== undefined) {
      if (this.meta.default === null) {
        const nullOption = this.meta.options.find((obj) => obj.key === null);
        if (nullOption) {
          this.setupDefaultValue(nullOption);
        }
      } else {
        const defaultOption = this.meta.options.find((obj) => obj.key === this.meta.default);
        if (defaultOption) {
          this.setupDefaultValue(defaultOption);
        }
      }
    }

    this.triggerUpdateComponent$.subscribe({
      next: () => {
        if (this.meta?.default !== undefined) {
          if (this.meta.default === null) {
            const nullOption = this.meta.options.find((obj) => obj.key === null);
            if (nullOption) {
              this.setupDefaultValue(nullOption);
              return;
            }
          } else {
            const defaultOption = this.meta.options.find((obj) => obj.key === this.meta.default);
            if (defaultOption) {
              this.setupDefaultValue(defaultOption);
              // NON emettere evento durante aggiornamento programmatico
              return;
            }
          }
        }

        // Altrimenti, cerca "Volkswagen" (comportamento legacy)
        const brandDefault = this.meta.options.find((obj) => obj.value === 'Volkswagen');
        if (brandDefault) {
          this.setupDefaultValue(brandDefault);
        }
      },
    });
  }

  setupDefaultValue(defaultOption): void {
    if (defaultOption) {
      this.control.setValue(defaultOption.key);
    }
  }

  onSelectionChange($event: MatSelectChange) {
    this.triggerSelectionBrand$.next($event.value);
  }
}
